import React from "react";
import Select from "react-select";

const LanguageDropdown = ({
  languages,
  chosenLang,
  changeLanguage,
  editing,
}) => {
  const options = languages.map((lang) => ({
    value: lang.name,
    label: lang.name,
  }));

  const handleChange = (selectedOption) => {
    changeLanguage(selectedOption.value);
  };

  return (
    <label>
      <Select
        styles={{}}
        options={options}
        onChange={handleChange}
        value={options.find((option) => option.value === chosenLang.name)}
        isDisabled={editing}
        isSearchable
      />
    </label>
  );
};

export default LanguageDropdown;
